module.exports = __webpack_public_path__ + "img/director-test-icon5.7ec02d2f.png";